import { render, staticRenderFns } from "./ContentTagPicker.vue?vue&type=template&id=9a1a6ce2&scoped=true&"
import script from "./ContentTagPicker.vue?vue&type=script&lang=js&"
export * from "./ContentTagPicker.vue?vue&type=script&lang=js&"
import style0 from "./ContentTagPicker.vue?vue&type=style&index=0&id=9a1a6ce2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1a6ce2",
  null
  
)

export default component.exports